import React, { useState, useEffect } from 'react';
// import { Radar } from '@ant-design/charts';
// const { Radar } = require('@ant-design/charts');
const { Radar } = window.charts;

const ReportRadar = ({ data }) => {
  const config = {
    data,
    xField: 'dimension',
    yField: 'score',
    meta: {
      score: {
        alias: '分数',
        min: 0,
        nice: true,
      },
    },
    xAxis: {
      line: null,
      tickLine: null,
    },
    yAxis: {
      label: false,
      grid: {
        alternateColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
    // 开启辅助点
    point: {},
    area: {},
  };
  return <Radar {...config} />;
  // return null;
};

export default ReportRadar;
